import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GalleryTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LazyYouTube.tsx");
